import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-equipmentlineitemtype-dropdown',
  templateUrl: './EquipmentLineItemTypeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => EquipmentLineItemTypeDropdownComponent)}]
})
export class EquipmentLineItemTypeDropdownComponent extends BaseDropdownComponent {

    
    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getEquipmentLineItemTypes().subscribe(x=> this.onGetEquipmentLineItemTypesDone(x));
    }
    
    onGetEquipmentLineItemTypesDone(items: ent.EquipmentLineItemType[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}